<div class="xuatkho-nhieu-container">
  <!-- Form Content -->
  <div class="form-content">
    <!-- Row 1: Kho -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label required-label">{{'Kho' | translate}}</label>
        <ng-select #slKho
                   class="custom-select-red"
                   [tabIndex]="2"
                   [openOnEnter]="false"
                   [items]="dskhohangs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.KhoHangId">
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()" class="add-new-link-red">+ Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Row 2: Quyển số & Số phiếu -->
    <div class="row form-group">
      <div class="col-md-6">
        <label class="form-label">{{'Quyển số' | translate}}</label>
        <input type="text" 
               tabIndex="3" 
               class="form-control custom-input" 
               placeholder="Nhập quyển số" 
               [(ngModel)]="doituongSelect.QuyenSo">
      </div>
      <div class="col-md-6">
        <label class="form-label">{{'Số phiếu' | translate}}</label>
        <input class="form-control custom-input"
               maxlength="20"
               tabindex="4"
               currencyMask
               [(ngModel)]="doituongSelect.SoPhieu"
               name="value"
               placeholder="Nhập số phiếu"
               [options]="ngxCurrencyOption2s" 
               autocomplete="off" />
      </div>
    </div>

    <!-- Row 3: Ngày thu tiền & Ngày phát -->
    <div class="row form-group">
      <div class="col-md-6">
        <label class="form-label">{{'Ngày thu tiền' | translate}}</label>
        <kendo-dateinput tabindex="5" 
                         class="custom-datepicker-red"
                         placeholder="Chọn ngày thu tiền" 
                         [format]="'dd/MM/yyyy'" 
                         [(value)]="doituongSelect.NgayThuTien">
        </kendo-dateinput>
      </div>
      <div class="col-md-6">
        <label class="form-label">{{'Ngày phát' | translate}}</label>
        <kendo-dateinput tabindex="6" 
                         class="custom-datepicker-red"
                         placeholder="Chọn ngày phát" 
                         [format]="'dd/MM/yyyy'" 
                         [(value)]="doituongSelect.Ngay">
        </kendo-dateinput>
      </div>
    </div>

    <!-- Row 4: Phương thức -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label required-label">{{'Phương thức' | translate}}</label>
        <ng-select #slPhuongThuc
                   class="custom-select-red"
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputphuongthucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.PhuongThuc"> 
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()" class="add-new-link-red">+ Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Row 5: Ghi chú -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label">Ghi chú</label>
        <textarea type="text" 
                  tabIndex="15" 
                  rows="3" 
                  class="form-control custom-textarea" 
                  placeholder="Nhập ghi chú (nếu có)" 
                  [(ngModel)]="doituongSelect.GhiChu">
        </textarea>
      </div>
    </div>

    <!-- Product Section -->
    <div class="product-section">
      <div class="section-header">
        <h6 class="section-title">Danh sách sản phẩm</h6>
        <button class="btn btn-add-product" (click)="ThemSanPham()">
          <i class="fas fa-plus-circle mr-2"></i>
          {{'Thêm sản phẩm' | translate}}
        </button>
      </div>

      <!-- Products Table -->
      <div class="table-responsive">
        <table class="table table-products">
          <thead>
            <tr>
              <th style="min-width:200px">Sản phẩm</th>
              <th style="min-width:120px">Đơn vị</th>
              <th style="min-width:130px;text-align:right">Đơn giá</th>
              <th style="min-width:120px;text-align:right">Số lượng</th>
              <th style="min-width:150px;text-align:right">Tổng tiền</th>
              <th style="min-width:150px">Đăng ký</th>
              <th style="min-width:100px;text-align:center">Thanh toán</th>
              <th style="min-width:80px;text-align:center">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of doituongSelect.ChiTiets; let i = index" class="product-row">
              <td>
                <ng-select #slSanPham
                           [dropdownPosition]="u.showpopup"
                           class="custom-select-red compact-select"
                           labelForId="{{i}}_1_1"
                           [openOnEnter]="false"
                           [items]="dssanphams"
                           bindValue="Id"
                           bindLabel="Ten"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           (change)="changeSanPham($event, i)"
                           [(ngModel)]="u.SanPhamId">
                  <ng-template ng-footer-tmp>
                    <a (click)="AddSanPham()" class="add-new-link-red">+ Thêm mới</a>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.Ten}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <ng-select #slDonViTinh
                           [dropdownPosition]="u.showpopup"
                           class="custom-select-red compact-select"
                           labelForId="{{i}}_1_2"
                           [disabled]="true"
                           [openOnEnter]="false"
                           [items]="dsdonvitinhs"
                           bindValue="Id"
                           bindLabel="Ten"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           [(ngModel)]="u.DonViTinhId">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.Ten}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <input id="{{i}}_1_3" 
                       class="form-control custom-input text-right"
                       maxlength="20"
                       currencyMask
                       [(ngModel)]="u.DonGia"
                       (ngModelChange)="changeDonGia(i)"
                       name="value"
                       placeholder="Đơn giá"
                       [options]="ngxCurrencyOptions" 
                       autocomplete="off" />
              </td>
              <td>
                <input id="{{i}}_1_4" 
                       class="form-control custom-input text-right"
                       maxlength="20"
                       currencyMask
                       [(ngModel)]="u.SoLuong"
                       (ngModelChange)="changeDonGia(i)"
                       name="value"
                       placeholder="Số lượng"
                       [options]="ngxCurrencyOptions" 
                       autocomplete="off" />
              </td>
              <td>
                <input id="{{i}}_1_5" 
                       class="form-control custom-input text-right amount-highlight"
                       maxlength="20"
                       currencyMask
                       [(ngModel)]="u.SoTien"
                       name="value"
                       placeholder="Số tiền"
                       [options]="ngxCurrencyOptions" 
                       autocomplete="off" 
                       readonly />
              </td>
              <td>
                <ng-select #slDangKy
                           [dropdownPosition]="u.showpopup"
                           class="custom-select-red compact-select"
                           labelForId="{{i}}_1_6"
                           [openOnEnter]="false"
                           [items]="inputdangkys"
                           bindValue="Id"
                           bindLabel="Ten"
                           notFoundText="Không có dữ liệu"
                           [searchFn]="comboSearchFn2"
                           [(ngModel)]="u.DangKy"
                           (change)="changeDangKy($event,i)">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="rTableRow">
                      <div class="rTableCell_1">{{item.Ten}}</div>
                    </div>
                  </ng-template>
                </ng-select>
              </td>
              <td style="text-align:center">
                <div class="custom-checkbox-inline">
                  <label>
                    <input id="{{i}}_1_7" type="checkbox" [(ngModel)]="u.DaThanhToan" />
                    <span class="checkmark-inline"></span>
                  </label>
                </div>
              </td>
              <td style="text-align:center">
                <button class="btn btn-delete-row" (click)="deleterow(i)" title="Xóa">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="!doituongSelect.ChiTiets || doituongSelect.ChiTiets.length === 0">
              <td colspan="8" class="text-center text-muted py-4">
                <i class="fas fa-box-open fa-2x mb-2 d-block"></i>
                Chưa có sản phẩm nào. Nhấn "Thêm sản phẩm" để bắt đầu.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="form-footer">
    <div class="footer-left"></div>
    <div class="footer-right">
      <button class="btn btn-cancel" (click)="closeModal()">
        {{'Hủy bỏ' | translate}}
      </button>
      <button type="submit" class="btn btn-save-red" (click)="saveproduct()">
        {{'Lưu lại' | translate}}
      </button>
    </div>
  </div>
</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
<bs-modal #mdKhoHang class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới kho hàng</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhoHang.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-khohangedit #dtekhohangedit (save)="saveModal_Kho($event)"></app-danhmuc-khohangedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdNhaCungCap class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới nhà cung cấp</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdNhaCungCap.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-nhacungcapedit #dtenhacungcapedit (save)="saveModal_NhaCungCap($event)"></app-danhmuc-nhacungcapedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #mdSanPham class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới sản phẩm</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdSanPham.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-sanphamedit #dtesanphamedit (save)="saveModal_SanPham($event)"></app-danhmuc-sanphamedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdChonHocVien class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn học sinh</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonHocVien.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chonhocvienedit #chonhocvienedit (save)="saveModal($event)"></app-tonghop-chonhocvienedit>
  </bs-modal-body>
</bs-modal>
